import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import BidNotifications from "./components/feature/BidNotifications";
import { useEffect } from "react";

function RepTracker() {
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const rep = params.get('rep');
    if (rep) {
      localStorage.setItem('ref', rep);
    }
  }, [location.search]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <RepTracker />
        <AppRoutes />
        <BidNotifications />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
